import {PERSIST_STATE_CHANGE} from './actionTypes'

export function persistStateChange(payload)
{
    return {
        type: PERSIST_STATE_CHANGE,
        payload
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence/src/actions/actions.js